<template>
  <svg
    :width="props.width"
    :height="props.height"
    viewBox="0 0 710 376"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="layer1">
      <g id="g3877">
        <path
          id="path3401"
          d="M334.661 188.157C334.661 84.6838 418.538 0.79895 522.019 0.79895C625.493 0.79895 709.378 84.6838 709.378 188.157C709.378 291.639 625.493 375.516 522.019 375.516C418.538 375.516 334.661 291.639 334.661 188.157Z"
          :fill="props.fill"
        />
        <path
          id="path3405"
          d="M501.438 112.585C484.888 76.988 457.009 47.725 422.427 29.43C425.015 27.8052 427.641 26.2404 430.304 24.7434C465.517 44.5429 493.674 75.3857 510.096 112.585H501.438ZM422.427 346.892C460.988 326.491 491.214 292.451 506.688 251.205H515.091C499.798 293.993 469.391 329.59 430.304 351.579C427.641 350.082 425.015 348.517 422.427 346.892Z"
          :fill="props.fill2"
        />
        <path
          id="path3409"
          d="M228.261 112.585C250.152 63.0111 292.933 24.7134 345.546 8.82559C343.244 8.73538 340.927 8.69025 338.61 8.69025C266.491 8.69025 204.309 51.2307 175.783 112.585H167.125C196.177 46.7547 262.03 0.806519 338.61 0.806519C371.92 0.806519 403.2 9.50264 430.304 24.7435C427.641 26.2405 425.015 27.8052 422.427 29.4301C415.153 25.5785 407.57 22.2084 399.747 19.3723C354.566 35.6814 317.983 69.4956 298.003 112.585H289.352C308.535 68.999 343.846 34.1317 387.899 15.5433C381.82 13.8131 375.614 12.3913 369.295 11.3081C310.355 21.426 261.315 60.1299 236.919 112.585H228.261ZM345.373 367.504C288.54 350.3 243.126 306.827 223.258 251.205H231.654C253.725 310.009 305.767 354.159 369.175 365.037C375.539 363.939 381.798 362.509 387.921 360.772C339.867 340.43 302.058 300.606 284.41 251.205H292.805C311.205 300.237 350.451 339.084 399.747 356.943C407.578 354.107 415.153 350.744 422.427 346.892C425.015 348.517 427.641 350.082 430.304 351.579C403.2 366.82 371.92 375.508 338.61 375.508C257.253 375.508 188.015 323.663 162.13 251.205H170.525C196.049 319.224 261.676 367.625 338.61 367.625C340.875 367.625 343.131 367.587 345.373 367.504Z"
          :fill="props.fill"
        />
        <path
          id="path3413"
          d="M83.7814 223.664V175.467C83.7814 161.362 75.8375 153.29 63.5305 153.29C53.9166 153.29 48.2746 156.111 44.6863 159.444C41.4817 156.111 35.9676 153.29 25.5863 153.29C13.9187 153.29 6.23065 155.472 0.716522 158.42V223.664H20.328V168.418C21.7423 167.771 23.149 167.387 25.5863 167.387C30.3256 167.387 32.3793 170.72 32.3793 175.467V223.664H52.1187V169.313C53.5329 168.027 55.3233 167.387 57.6328 167.387C62.1162 167.387 64.1699 170.592 64.1699 175.467V223.664H83.7814Z"
          :fill="props.fill"
        />
        <path
          id="path3417"
          d="M149.634 219.692V154.569H129.76V208.408C128.353 209.055 126.555 209.559 124.637 209.559C120.146 209.559 118.227 206.49 118.227 202.511V154.569H98.4882V200.329C98.4882 218.534 108.23 224.943 124.253 224.943C135.785 224.943 144.376 223.017 149.634 219.692Z"
          :fill="props.fill"
        />
        <path
          id="path3421"
          d="M216.074 223.664V175.467C216.074 160.722 208.642 153.29 189.67 153.29C178.642 153.29 170.314 155.344 164.672 158.42V223.664H184.284V168.418C185.69 167.771 186.977 167.643 189.542 167.643C194.537 167.643 196.335 170.464 196.335 175.467V223.664H216.074Z"
          :fill="props.fill"
        />
        <path
          id="path3425"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M280.092 219.82V123.034H260.473V155.081C259.066 154.441 257.012 153.802 252.401 153.802C237.912 153.802 227.915 167.515 227.915 189.308C227.915 213.02 238.687 224.943 256.757 224.943C267.913 224.943 274.45 223.153 280.092 219.82ZM260.473 209.695C259.578 210.206 258.299 210.206 257.268 210.206C250.219 210.206 247.526 202.511 247.526 188.541C247.526 176.234 249.58 167.004 257.396 167.004C258.555 167.004 259.706 167.26 260.473 167.26V209.695Z"
          :fill="props.fill"
        />
        <path
          id="path3429"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M315.689 134.062C315.689 128.292 310.942 123.681 305.18 123.681C299.538 123.681 294.919 128.292 294.919 134.062C294.919 139.704 299.538 144.316 305.18 144.316C310.942 144.316 315.689 139.704 315.689 134.062ZM295.43 223.664H315.042V154.569H295.43V223.664Z"
          :fill="props.fill"
        />
        <path
          id="path3433"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M401.357 188.541C401.357 165.853 391.743 153.29 374.305 153.29C365.722 153.29 358.921 155.344 354.31 158.42V251.227H368.024V223.408C369.95 224.048 372.387 224.815 376.103 224.815C390.847 224.815 401.357 211.101 401.357 188.541ZM387.771 189.053C387.771 201.487 384.566 214.945 373.154 214.945C370.98 214.945 369.438 214.562 368.024 214.05V164.311C369.438 163.543 371.356 163.16 374.049 163.16C384.303 163.16 387.771 175.339 387.771 189.053Z"
          :fill="props.fill2"
        />
        <path
          id="path3437"
          d="M456.956 223.664V174.444C456.956 160.722 449.396 153.29 437.345 153.29C432.726 153.29 428.498 154.697 424.91 156.751V123.034H411.196V223.664H424.91V165.725C427.603 164.183 430.424 163.288 433.756 163.288C439.526 163.288 443.37 167.26 443.37 174.444V223.664H456.956Z"
          :fill="props.fill2"
        />
        <path
          id="path3441"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M510.841 219.82V177.257C510.841 159.316 501.099 153.29 489.176 153.29C479.953 153.29 473.288 156.111 469.692 158.42L472.641 167.515C475.973 165.469 481.232 163.543 486.874 163.543C493.411 163.543 497.766 167.004 497.766 175.083V178.032C480.081 180.206 466.104 185.72 466.104 203.669C466.104 216.743 473.799 224.943 489.695 224.943C499.437 224.943 506.102 223.017 510.841 219.82ZM497.766 214.05C496.232 214.945 493.411 215.585 490.462 215.585C483.03 215.585 478.922 211.357 478.922 203.278C478.922 191.874 485.46 188.285 497.766 186.359V214.05Z"
          :fill="props.fill2"
        />
        <path
          id="path3445"
          d="M551.531 153.418C536.154 152.906 528.97 154.697 522.689 158.421V223.664H536.41V165.214C539.615 163.288 544.354 163.032 548.589 164.958L551.531 153.418Z"
          :fill="props.fill2"
        />
        <path
          id="path3449"
          d="M635.664 223.664V174.316C635.664 160.722 627.464 153.29 616.436 153.29C607.845 153.29 602.211 155.983 598.103 160.339C594.906 156.367 589.392 153.29 579.778 153.29C569.389 153.29 562.98 155.344 557.729 158.42V223.664H571.443V164.958C573.625 163.799 575.806 163.288 579.65 163.288C586.06 163.288 589.904 168.027 589.904 174.316V223.664H603.489V167.643C605.927 164.822 609.004 163.415 612.592 163.415C618.49 163.415 621.95 167.387 621.95 174.316V223.664H635.664Z"
          :fill="props.fill2"
        />
        <path
          id="path3453"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M689.428 219.82V177.257C689.428 159.316 679.694 153.29 667.77 153.29C658.54 153.29 651.875 156.111 648.287 158.42L651.236 167.515C654.568 165.469 659.819 163.543 665.461 163.543C671.998 163.543 676.354 167.004 676.354 175.083V178.032C658.668 180.206 644.691 185.72 644.691 203.669C644.691 216.743 652.387 224.943 668.282 224.943C678.024 224.943 684.689 223.017 689.428 219.82ZM676.354 214.05C674.819 214.945 671.998 215.585 669.049 215.585C661.617 215.585 657.517 211.357 657.517 203.278C657.517 191.874 664.054 188.285 676.354 186.359V214.05Z"
          :fill="props.fill2"
        />
      </g>
    </g>
  </svg>
</template>

<script setup lang="ts">
const props = defineProps({
  width: {
    type: [Number, String],
    default: 710
  },
  height: {
    type: [Number, String],
    default: 376
  },
  fill: {
    type: String,
    default: '#ffffff'
  },
  fill2: {
    type: String,
    default: '#414141'
  }
})
</script>
